import { render, staticRenderFns } from "./InputProtocolo.vue?vue&type=template&id=254a9683&"
import script from "./InputProtocolo.vue?vue&type=script&lang=js&"
export * from "./InputProtocolo.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports